import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../providers/AuthProvider";

export default function ProtectedRoute({ children }) {
  const { isAuthenticated } = useAuth();
  if (!isAuthenticated) return <Navigate to="/signin" replace />;
  return children;
}
